import {
    type GeneratedInsight,
    GeneratedInsightType,
} from "@amzn/d16-g-client-deck-builder-typescript-client";
import React from "react";

import { CuratedInsightCard } from "./CuratedInsightCard/CuratedInsightCard";
import { PackagedInsightCard } from "./PackagedInsightCard/PackagedInsightCard";

export interface GeneratedInsightCardProps {
    insight: GeneratedInsight;
}

export const GeneratedInsightCard: React.FunctionComponent<{
    insight: GeneratedInsight;
}> = ({ insight }) => {
    if (insight.insightType === GeneratedInsightType.PKG)
        return <PackagedInsightCard insight={insight} />;
    else if (insight.insightType === GeneratedInsightType.WB)
        return <CuratedInsightCard insight={insight} />;
    else return <></>;
};
